import request from '../request';

const execute = async ({ dateDay, userId, limit, offset }) => {
  const query = `?userId=${userId}&date=${dateDay}&limit=${limit}&offset=${offset}`;

  try {
    const response = await request.get(`/scales${query}`);

    if (response.err) {
      return {
        err: true,
        data: {
          ...response.data,
        },
      };
    }
    return { err: false, data: response?.data };
  } catch (error) {
    return {
      err: true,
      data: {
        errorMessage: 'Erro interno',
        error,
      },
    };
  }
};

export default execute;
